import { FileEditUploader } from "@/entities";
import { Panel, PanelHeader, PanelBody } from "@/shared";

interface Props {
  panelTitle: string;
  queryKey: string;
  table: string;
  column: string;
  id: string;
  timestamp: string;
  file: any;
  accept: string;
}
export function AdminCommonFileCoverEdit({
  panelTitle,
  queryKey,
  table,
  column,
  id,
  timestamp,
  file,
  accept,
}: Props) {
  return (
    <Panel queryKey={queryKey}>
      <PanelHeader>{panelTitle}</PanelHeader>
      <PanelBody className="p-0">
        <FileEditUploader
          queryKey={queryKey}
          table={table}
          column={column}
          id={id}
          timestamp={timestamp}
          file={file}
          accept={accept}
        />
      </PanelBody>
    </Panel>
  );
}
